import Auth from '../modules/Authentication'
import {apiUrl} from '../variables/index'
import {handleErrors, handleResponse} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class ApprovalsApi {
  constructor() {
    this.auth = new Auth()
  }
  list = ({direct}) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(
      `${apiUrl}approvals/?select=*` +
        (direct ? `&direct=${direct || ''}` : ''),
      {headers},
    )
      .then(handleErrors)
      .then(handleResponse)
  }
  approve = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}approvals/approve`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
}
